/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { UnderlineTabBar, type UnderlineTabOption } from '../../../shared/ui/UnderlineTabBar';
import type { AuditCategoryFilter } from './useTeamHistoryFilters';
import { AUDIT_CATEGORY_LABELS, type AuditCategory } from '../../../shell/audit/auditCategories';

const TAB_OPTIONS: UnderlineTabOption<AuditCategoryFilter>[] = [
  { value: 'all', label: 'Todos' },
  ...(Object.keys(AUDIT_CATEGORY_LABELS) as AuditCategory[]).map((cat) => ({
    value: cat,
    label: AUDIT_CATEGORY_LABELS[cat],
  })),
];

type Props = {
  value: AuditCategoryFilter;
  onChange: (value: AuditCategoryFilter) => void;
};

export function AuditCategoryTabs({ value, onChange }: Props) {
  return (
    <UnderlineTabBar
      options={TAB_OPTIONS}
      value={value}
      onChange={onChange}
      testIDPrefix="perfil.team.history.tab"
    />
  );
}
